import { Component, OnInit } from '@angular/core';
import { SecondLevelReviewPacim } from '@shared/model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'pac-do-next-dialog',
    templateUrl: './pac-do-next-dialog.component.html',
    styleUrls: ['./pac-do-next-dialog.component.scss'],
    standalone: false
})
export class PacDoNextDialogComponent implements OnInit {
  secondLevelReviews: SecondLevelReviewPacim[];
  selectedSecondLevelReview: SecondLevelReviewPacim;
  routingPending = false;

  constructor(
    private config: DynamicDialogConfig<SecondLevelReviewPacim[]>,
    private ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.secondLevelReviews = this.config.data;
  }

  onDoNextRoute(): void {
    this.ref.close(this.selectedSecondLevelReview);
  }

  onCancel(): void {
    this.ref.close(null);
  }
}
